import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  ButtonLogin,
  Buttons,
  HeaderContainer,
  StyledDiv,
  Logo,
  LogoutContainer,
  StyledText,
  MenuContainer,
  Test,
} from "./Header.style";

import { ReactComponent as LogoutIcon } from "../../assets/icons/logout.svg";
import { ReactComponent as Menu } from "../../assets/icons/menu.svg";

import { FRONT_URL } from "../../api";
import { selectedLocale } from "../../store/slices/common/slice";
import { logout } from "../../store/slices/auth/asyncThunks";
import { selectLoggedIn } from "../../store/slices/auth/slice";

import Icon from "../utils/Icon";
import openToast from "../../utils/toast";
import SmallScreensSideBarModal from "../Modal/SmallScreensSideBarModal";
import LocaleSelection from "../LocaleSelection/LocaleSelection";

const Header = ({ hideLogin }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toastId = useRef(null);

  const [openSidebarModal, setOpenSidebarModal] = useState(false);

  const locale = useSelector(selectedLocale);
  const loggedIn = useSelector(selectLoggedIn);
  const ar = locale === "ar";

  const handleLogout = () => {
    navigate("/");
    dispatch(logout())
      .unwrap()
      .then(() => {})
      .catch((error) => {
        openToast(toastId, "logout-sidebar", "error", t(error.message));
      });
  };

  return (
    <HeaderContainer>
      <StyledDiv
        onClick={() => {
          navigate("/");
        }}
      >
        <Logo />
        {FRONT_URL !== "https://csr.ygii.app" && <Test>TEST</Test>}
      </StyledDiv>
      <MenuContainer $ar={ar}>
        <Menu
          onClick={() => {
            setOpenSidebarModal(!openSidebarModal);
          }}
        />
      </MenuContainer>

      <Buttons $gap>
        {!hideLogin &&
          (loggedIn ? (
            <LogoutContainer onClick={handleLogout}>
              <StyledText>{t("logout")}</StyledText>
              <Icon icon={<LogoutIcon />} selectedLocale={ar} />
            </LogoutContainer>
          ) : (
            <ButtonLogin
              onClick={() => {
                navigate("/");
              }}
            >
              {t("log-in")}
            </ButtonLogin>
          ))}
        <LocaleSelection color />
      </Buttons>

      <SmallScreensSideBarModal
        hideLogin={hideLogin}
        handleLogout={handleLogout}
        open={openSidebarModal}
        setOpenSidebarModal={setOpenSidebarModal}
        loggedIn={loggedIn}
        close={() => setOpenSidebarModal(false)}
      />
    </HeaderContainer>
  );
};

export default Header;
